<div class="form" [formGroup]="formArray">
  <div
    class="{{ group?.value['type'] }}"
    *ngFor="let group of getFormArray()?.controls; let i = index"
    [formGroupName]="i"
  >
    <div class="mb-4">
      <mat-checkbox
        formControlName="checked"
        [attr.data-testid]="group?.value['type'] + '-checkbox'"
        (change)="onCheckboxChange($event.checked, group)"
      >
        {{ getLabel(group?.value['type']) }}
      </mat-checkbox>
    </div>
    <mat-form-field>
      <textarea
        [attr.data-testid]="group?.value['type'] + '-textarea'"
        matInput
        formControlName="text"
        #textarea
        cdkTextareaAutosize
        [placeholder]="getPlaceHolder(group?.value['type'])"
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="2"
        cdkAutosizeMaxRows="100"
        [readonly]="!isChecked(group)"
        [maxlength]="maxLength"
      ></textarea>
      <mat-hint align="end">{{ group?.value['text']?.length || 0 }} / {{ maxLength }}</mat-hint>
      <mat-error *ngIf="group.status === 'INVALID'">{{ getError(group, 'text') }} </mat-error>
    </mat-form-field>
  </div>
</div>
